import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/Logo For Website 01.png';

const CalendlyPage = ({ onSignup }) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="w-full px-4 sm:px-6 lg:px-8 sticky top-0 bg-white/80 backdrop-blur-sm z-50 border-b border-zinc-100">
        <div className="max-w-6xl mx-auto flex justify-between items-center py-4">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src={logo}
                alt="Moinduel Logo"
                className="h-8 w-auto object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <span 
                className="font-bold text-xl text-zinc-900 hidden"
                style={{ display: 'none' }}
              >
                Moinduel
              </span>
            </Link>
          </div>
          <button 
            onClick={onSignup}
            className="px-6 py-2 rounded-full border border-zinc-200 hover:bg-zinc-50 hover:border-zinc-300 transition-colors"
          >
            Sign up
          </button>
        </div>
      </nav>

      {/* Calendly Integration */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-zinc-900 mb-4">Schedule a Demo</h1>
          <p className="text-zinc-600">Choose a time that works best for you</p>
        </div>
        
        {/* Calendly iframe */}
        <div className="h-[700px] w-full">
          <iframe
            src="https://calendly.com/abdurasulovs01-27/30min?month=2024-11"
            width="100%"
            height="100%"
            frameBorder="0"
            title="Schedule a demo with Moinduel"
          />
        </div>
      </div>
    </div>
  );
};

export default CalendlyPage;